import { useContrastMode } from "@/app/providers/contrast-mode-provider"
import { assetUrl } from "@/lib/asset-url"
import { cn } from "@/lib/utils"

/**
 * ENT contrast icon + optional label. Accepts className so the header can
 * style it as a matching pill on desktop / icon pill on mobile.
 */
export function ContrastToggle({
  className,
  showLabel = true,
}: {
  className?: string
  showLabel?: boolean
}) {
  const { highContrast, toggle } = useContrastMode()
  const label = highContrast ? "Standard contrast" : "High contrast"

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={highContrast}
      aria-label={label}
      title={label}
      className={cn(
        "color-contrast-btn contrast-button inline-flex shrink-0 cursor-pointer items-center gap-1.5 outline-none ring-ring/30 transition focus-visible:ring-2",
        className,
      )}
    >
      <span
        aria-hidden
        className="contrast-icon block size-5 shrink-0 bg-contain bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${assetUrl(
            highContrast
              ? "/assets/img/contrast-icon-hover.png"
              : "/assets/img/contrast-icon.png",
          )})`,
        }}
      />
      {showLabel ? (
        <span className="hidden font-sans text-[13px] font-medium leading-none text-foreground/80 lg:inline">
          {label}
        </span>
      ) : null}
    </button>
  )
}
